import {
  PencilRuler, HardHat, PaintRoller, Plug, Hammer, Trees,
  ClipboardList, FileCheck, KeyRound,
} from "lucide-react";

export const PHONE = "8050017143";
export const PHONE_LINK = "tel:+918050017143";
export const WHATSAPP = "9741250598";
export const WA_LINK = (msg = "Hi D & N Constructions, I'm interested in discussing my construction project.") =>
  `https://wa.me/919741250598?text=${encodeURIComponent(msg)}`;
export const EMAIL = "DandNconstructions2026@gmail.com";
export const ADDRESS = "Pandithanahalli, Tumkur, Karnataka – 572104";
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Pandithanahalli, Tumkur, Karnataka 572104")}`;

export const MICROCOPY = [
  "Built around your vision.",
  "Planned with purpose.",
  "Made for the way you live.",
  "From idea to handover.",
  "Your home. Your choices. Our expertise.",
  "Built with care.",
];

export const SERVICES = [
  {
    id: "planning-design", icon: PencilRuler, name: "Planning & Design",
    desc: "Architectural planning, floor plans, 2D design, 3D elevation design and structural design — planned with purpose before a single brick is laid.",
    items: ["Architectural planning", "Floor plans", "2D design", "3D elevation design", "Structural design"],
  },
  {
    id: "construction", icon: HardHat, name: "Construction",
    desc: "Complete house construction from independent homes and villas to duplex, G+1 to G+6 buildings, apartments and commercial spaces.",
    items: ["Complete house construction", "Civil construction", "Villa construction", "Duplex construction", "G+1 to G+6 construction", "Commercial construction", "Apartment construction"],
  },
  {
    id: "interiors", icon: PaintRoller, name: "Interiors & Finishing",
    desc: "Interior design, flooring, tiling and painting that make a structure feel like home.",
    items: ["Interior design", "Flooring", "Tiling", "Painting"],
  },
  {
    id: "building-systems", icon: Plug, name: "Building Systems",
    desc: "Electrical, plumbing and other construction-related systems, executed safely and to standard.",
    items: ["Electrical", "Plumbing", "Other building systems"],
  },
  {
    id: "renovation", icon: Hammer, name: "Renovation",
    desc: "Home renovation, remodeling and structural or space improvements that give existing buildings new life.",
    items: ["Home renovation", "Space improvements", "Remodeling"],
  },
  {
    id: "outdoor", icon: Trees, name: "Outdoor",
    desc: "Landscaping that completes your home, inside and out.",
    items: ["Landscaping"],
  },
  {
    id: "project-management", icon: ClipboardList, name: "Project Management",
    desc: "End-to-end coordination, site management, execution and quality monitoring — with regular updates to you.",
    items: ["End-to-end coordination", "Site management", "Execution", "Quality monitoring"],
  },
  {
    id: "approvals", icon: FileCheck, name: "Approvals & Documentation",
    desc: "Building approvals, permissions and documentation assistance handled properly.",
    items: ["Building approvals", "Permissions", "Documentation assistance"],
  },
  {
    id: "turnkey", icon: KeyRound, name: "Turnkey Construction",
    desc: "Complete project execution from planning through handover. One team, one responsibility, zero runaround.",
    items: ["Planning to handover", "Single point of accountability"],
  },
];

export const WHY_ITEMS = [
  "Quality construction", "Transparent pricing", "Detailed estimates", "No hidden costs",
  "Quality materials", "Experienced engineers & workers", "Professional planning", "Customized homes",
  "On-time completion", "Regular customer updates", "Transparent project tracking",
  "Direct communication with founders", "End-to-end turnkey service", "Strong local knowledge",
  "Post-construction support", "Proper documentation", "Modern & sustainable practices",
  "Safety-focused construction", "Customer satisfaction",
];

export const MATERIAL_TIERS = ["Basic", "Standard", "Premium", "Custom"];

export const MATERIAL_CATEGORIES = [
  { id: "structure", items: ["Cement", "Steel", "Concrete", "Blocks", "Other structural materials"] },
  { id: "exterior", items: ["Doors", "Windows", "Exterior finishes", "Roofing"] },
  { id: "interior", items: ["Flooring", "Tiles", "Paint", "Kitchen finishes", "Bathroom finishes"] },
  { id: "utilities", items: ["Electrical", "Plumbing", "Fixtures"] },
];

export const PROCESS_STEPS = [
  { id: "vision", name: "Your Vision", desc: "We start by understanding what you want to build and how you want to live." },
  { id: "planning", name: "Planning", desc: "Requirements, budget alignment and a clear plan for your project." },
  { id: "design", name: "Design", desc: "Floor plans, 2D and 3D elevations shaped around your vision." },
  { id: "estimate", name: "Estimate", desc: "A detailed, transparent estimate — no hidden costs." },
  { id: "approvals", name: "Approvals", desc: "Building approvals, permissions and documentation handled for you." },
  { id: "construction", name: "Construction", desc: "Quality construction with regular updates and transparent tracking." },
  { id: "finishing", name: "Finishing", desc: "Interiors, systems and finishing touches, done with care." },
  { id: "handover", name: "Handover", desc: "Your space, ready to belong to — with post-construction support." },
];

export const SERVICE_AREAS = [
  { name: "Tumakuru", desc: "Our home ground — where D & N began and where many of our projects stand." },
  { name: "Bengaluru", desc: "Residential and commercial projects across the city." },
  { name: "Surrounding Areas", desc: "We also take up projects around Tumakuru and Bengaluru — ask us about yours." },
];

export const PROJECT_LOCATIONS = ["All", "Bengaluru", "Tumakuru", "Surrounding Areas"];
export const PROJECT_TYPES = ["All", "Independent Homes", "Villas", "Duplex", "G+1", "G+2", "G+3", "G+4–G+6", "Apartments", "Commercial", "Renovation", "Farmhouses"];
